import React from 'react'
import { Flex } from 'antd'
import FiltersCard from './filters/FiltersCard'

const SideSection = () => {
    return (
        <Flex vertical gap={16}>
            <FiltersCard />
        </Flex>
    )
}

export default SideSection
